import type ReactEChartsComponent from 'echarts-for-react';
import type { EChartsReactProps } from 'echarts-for-react';
import { forwardRef, useEffect, useState } from 'react';
import { ClientOnly } from 'remix-utils/client-only';

const ClientEChartsRuntime = forwardRef<ReactEChartsComponent, EChartsReactProps>((props, ref) => {
  const [ReactECharts, setReactECharts] = useState<typeof import('echarts-for-react').default | null>(null);
  const [loadError, setLoadError] = useState(false);

  useEffect(() => {
    let isMounted = true;

    void import('echarts-for-react')
      .then(({ default: loadedReactECharts }) => {
        if (isMounted) {
          setReactECharts(() => loadedReactECharts);
        }
      })
      .catch(() => {
        if (isMounted) {
          setLoadError(true);
        }
      });

    return () => {
      isMounted = false;
    };
  }, []);

  if (!ReactECharts || loadError) {
    return null;
  }

  return <ReactECharts ref={ref} {...props} />;
});

ClientEChartsRuntime.displayName = 'ClientEChartsRuntime';

export const ClientECharts = forwardRef<ReactEChartsComponent, EChartsReactProps>((props, ref) => (
  <ClientOnly>{() => <ClientEChartsRuntime ref={ref} {...props} />}</ClientOnly>
));

ClientECharts.displayName = 'ClientECharts';
